import { microApi } from 'app/services/api';
import { ListResponse } from 'app/types';
import qs from 'qs';
import pick from 'lodash/pick';
import { IProduct } from 'app/types/interfaces/Product';

// const END_POINTS = 'admin/inspections/inspectors';
const END_POINTS = 'products';
export const productApi = microApi.injectEndpoints({
  endpoints: (build) => ({
    getProducts: build.query<
      {
        data: Array<IProduct>;
        pagination: {
          page: number;
          pageSize: number;
          pages: number;
          total: number;
        };
      },
      {
        current: number;
        pageSize: number;
        keywords?: string;
        categories?: Array<string | number>;
      }
    >({
      query: (params) => {
        const extra: any = {};
        if (params.categories && params.categories.length) {
          extra['categoryIds'] = params.categories.map((id: any) => id);
        }
        const queryString = qs.stringify(
          {
            pageNo: params.current,
            pageSize: params.pageSize,
            ...pick(params, ['keywords']),
            ...extra
          },
          {
            encodeValuesOnly: false,
            indices: false
          }
        );
        return {
          url: `${END_POINTS}${queryString ? '?' + queryString : ''}`,
          method: 'GET'
        };
      },
      transformResponse: (baseQueryReturnValue: ListResponse<any>) => {
        return {
          pagination: baseQueryReturnValue.data.pagination,
          data: baseQueryReturnValue.data.list
        };
      }
    }),
    getProductTags: build.query({
      query: (params) => {
        const queryString = qs.stringify(
          {
            pageNo: params.current,
            pageSize: params.pageSize,
            ...pick(params, ['keywords'])
          },
          {
            encodeValuesOnly: false,
            indices: false
          }
        );
        return {
          url: `${END_POINTS}/tags${queryString ? '?' + queryString : ''}`,
          method: 'GET'
        };
      },
      transformResponse: (baseQueryReturnValue: ListResponse<any>) => {
        return {
          pagination: baseQueryReturnValue.data.pagination,
          data: baseQueryReturnValue.data.records
        };
      }
    })
  })
});

export const {
  useLazyGetProductsQuery,
  useLazyGetProductTagsQuery,
  useGetProductsQuery
}: typeof productApi = productApi;
